import React, { FC, Fragment, ReactNode } from "react"
import { Dialog, Transition } from "@headlessui/react"
import clsx from "clsx"

import { FaTimes } from "react-icons/fa"
import { FlexBox } from "../wrapper"

export interface ModalProps {
  show: boolean
  onClose: () => void
  contentClassName?: string
  contentPadding?: string
  backdropClassName?: string
  closeButton?: boolean
  customCloseButton?: ReactNode
  children?: ReactNode
}

export const Modal = ({
  show = false,
  onClose,
  backdropClassName,
  contentClassName,
  contentPadding = "p-5",
  customCloseButton,
  children,
}: ModalProps) => {
  return (
    <Transition appear show={show} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-[1000] overflow-y-auto " onClose={onClose}>
        <FlexBox className="min-h-screen  px-4" justify="center" align="center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className={clsx("fixed inset-0 bg-backdrop", backdropClassName)} />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div
              className={clsx(
                "inline-block bg-white rounded z-[1000] min-h-10 w-[500px] max-h-[80%] relative",
                contentClassName,
                contentPadding
              )}
            >
              {customCloseButton ?? (
                <button
                  className="lg:hidden flex top-2.5 right-2.5 absolute z-[888] align-end"
                  onClick={onClose}
                >
                  <FaTimes />
                </button>
              )}
              {children}
            </div>
          </Transition.Child>
        </FlexBox>
      </Dialog>
    </Transition>
  )
}
